import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useEvent } from '../hooks/useEvent'
import { updateActorFieldValue, updateActorContactInfo,deleteActorField } from '../actions'
import { cdsFieldPatterns } from '../util/cdsFieldPattern'
import { useValidationCDS } from './useValidationCDS';
import { useCurrentShipmentType } from '../../hooks'



const diffParam = {carrier:"CARRIER_TRADER",representative:'AGENT'}


export const useActor = (containerKey = 'parties') => {
  const { saveForm,deleteForm} = useEvent(containerKey, true)
  const { isImportShipment } = useCurrentShipmentType ()

  const dispatch = useDispatch()
  const {validateError} = useValidationCDS("parties")
  const fieldPattern = cdsFieldPatterns(isImportShipment)()


  

  const savePartiesActorDetails = useCallback(async (params = {},key) => {
    
      try {
        let type
        if(params.actorType in diffParam){
           type = diffParam[`${params.actorType}`]
        }
        else{
          type= params.actorType.toUpperCase()
        }
        params.type = type
        
        validateError({
          [`${params?.actorType}.${key}`]: ''
       },
          { [`${params?.actorType}`]: { [key]: params?.[key] || `${params?.streetName} ${params?.streetNumber}` } },
          { [`${params?.actorType}.${key}`]: fieldPattern?.parties?.[`${params?.actorType}.${key}`] })
        const response = await saveForm({ [`${params.actorType}`]: params })
        if (response && !params.id) {
          const { id, roleId } = response.parties[params.actorType]
          dispatch(updateActorFieldValue(params.actorType, { id, roleId }))
        }
      } catch (e) {}
    },
    [saveForm]
  )


  const deletePartiesActor = useCallback(

    async (params={})=>{
      try{
        let type
        // const type = params.actorType == 'representative' ? 'AGENT' : params.actorType.toUpperCase()
        if(params.actorType in diffParam){
          type = diffParam[`${params.actorType}`]
       }
       else{
         type= params.actorType.toUpperCase()
       }
       params.type = type
      const response = await deleteForm({ [`${params.actorType}`]: params})
      
        if(response){
        dispatch(deleteActorField(params.actorType))
        }
      } catch (e) {}
    },
    [deleteForm]

  )


  return React.useMemo(
    () => ({      
      savePartiesActorDetails,
      deletePartiesActor,
      clearContactDetails: (actorType) =>
        dispatch(updateActorContactInfo(actorType, { name: '', email: '', phone: '' })),
      updateActorContactInfo: (actorType, payload) =>
        dispatch(updateActorContactInfo(actorType, payload)),
      updateActorFieldValue: (actorType, payload) =>
        dispatch(updateActorFieldValue(actorType, payload)),
      saveActorContactDetails: (actorType, payload, id) =>
        savePartiesActorDetails({ actorType, contact: payload, id }),
   
    }),
    [savePartiesActorDetails, updateActorContactInfo, updateActorFieldValue,deletePartiesActor]
  )
}
